import { render, staticRenderFns } from "./StrategiesStatusButton.vue?vue&type=template&id=032b42c5"
import script from "./StrategiesStatusButton.vue?vue&type=script&lang=js"
export * from "./StrategiesStatusButton.vue?vue&type=script&lang=js"
import style0 from "./StrategiesStatusButton.vue?vue&type=style&index=0&id=032b42c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports